var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"threeContent"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"before"}),_c('span',{staticStyle:{"color":"rgb(0, 102, 204)","cursor":"pointer","margin-left":"5px"},on:{"click":_vm.toThree}},[_vm._v("三层任务")]),_vm._v("\n            > 文件管理\n        ")]),_c('usage',{ref:"usage"}),_c('div',{staticClass:"right"},[_c('div',{attrs:{"title":'exe、bat、ps1、rar、zip、7z、reg、txt、dll、ini、cfg、doc、docx、xls、xlsx、jpg、gif、png、bmp、vbs'}},[_c('img',{staticClass:"type",attrs:{"src":require("@/assets/img/icon/u1488.png"),"alt":""}}),_vm._v("\n                支持的文件类型\n            ")]),_c('file-upload',{ref:"fileUpload",attrs:{"format":[
                    'exe',
                    'bat',
                    'ps1',
                    'rar',
                    'zip',
                    '7z',
                    'reg',
                    'txt',
                    'dll',
                    'ini',
                    'cfg',
                    'doc',
                    'docx',
                    'xls',
                    'xlsx',
                    'jpg',
                    'gif',
                    'png',
                    'bmp',
                    'vbs' ],"url":_vm.$HTTP_API.threeTierMission.uploadFile,"size":32768},on:{"fileResult":function($event){_vm.getFileList(1)}}})],1)],1),_c('div',{staticClass:"table-content"},[_c('table-list',{ref:"tableList",attrs:{"total":parseInt(_vm.total),"page":parseInt(_vm.page),"table-list":_vm.fileList,"loading":_vm.loading},on:{"pagechange":_vm.getFileList,"delAllFile":_vm.delAllFile,"refresh":_vm.refresh}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }